import React from "react";
import DatePicker from "react-datepicker";

const CustomDatePicker = React.forwardRef((props, ref) => (

    <DatePicker
        id={props.id}
        maxDate={props.maxDate}
        placeholderText={props.placeholderText}
        selected={props.selected}
        onChange={props.onChange}
        ref={ref}
        className={props.className}
        showMonthDropdown
        showYearDropdown
        scrollableYearDropdown
        yearItemNumber={40}
        clearButtonTitle={"Clear"}
        isClearable={true}
        yearDropdownItemNumber={props?.yearDropdown ? props?.yearDropdown : 40}
        onFocus={e => e.target.blur()}
        minDate={props.minDate}
        readOnly={props.readOnly}
        popperPlacement={props.placement}
        dropdownMode={props.dropdownMode ? props.dropdownMode : "scroll"}
    />

));

export default CustomDatePicker